<template>
    <CollapseSection
        title="Grupo Econômico"
        :expanded="expanded"
        :disabled="disabled"
        :loading="loading"
        section-id="grupo_economico"
        @toggleSection="$emit('toggleSection')"
    >
        <div class="pb-5">
            <div class="row">
                <div class="col-md-12">
                    <label class="dbo-ui" for="company_name">Grupo econômico</label>
                    <div v-if="editable">
                        <div class="custom-control custom-radio d-inline-block mr-4">
                            <input type="radio" id="grupo_economico_sim" name="grupo_economico" class="custom-control-input" 
                                v-model="selectedEconomicGroupTable" :value="true">
                            <label class="custom-control-label" for="grupo_economico_sim">Sim</label>
                        </div>
                        <div class="custom-control custom-radio d-inline-block mr-4">
                            <input type="radio" id="grupo_economico_nao" name="grupo_economico" class="custom-control-input" 
                                v-model="selectedEconomicGroupTable" :value="false">
                            <label class="custom-control-label" for="grupo_economico_nao">Não</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-12 pb-3">                        
                    <p v-if="!editable && !listEconomicGroupCompanies.length">Sem cadastros.</p>
                    <section id="cnpjs-grupo-economico" class="collapse" :class="{'collapsed' : !selectedEconomicGroupTable, 'show' : selectedEconomicGroupTable}">
                        <div class="d-flex justify-content-end" v-if="editable">
                            <button type="button" class="button btn btn-outline-secondary btn-sm" 
                                @click="$bvModal.show('show-modal-company')"
                                data-toggle="modal" data-target="#modal-nova-empresa">
                                    <i class="fa fa-plus mr-1"></i> Adicionar nova empresa
                            </button>
                        </div>

                        <div class="row mt-3">
                            <div class="col-12 col-lg-12">
                                <div class="scrollable-table" style="max-height: 410px">
                                    <table class="pretty font-14 list sticky-header">
                                        <thead>
                                            <tr>
                                                <th>CNPJ</th>
                                                <th>Nome</th>
                                                <th>Tipo</th>
                                                <th v-if="editable"></th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="!listEconomicGroupCompanies.length">
                                            <tr><td colspan="100%">Sem cadastros.</td></tr>
                                        </tbody>
                                        <tbody v-if="listEconomicGroupCompanies.length">
                                            <tr v-for="(company, index) in listEconomicGroupCompanies" :key="index">
                                                <td>{{ formatCnpj(company.cnpj) }}</td>
                                                <td>{{ company.company_name }}</td>
                                                <td>{{ economicGroupTypeLabel(company.type) }}</td>
                                                <td class="text-right" v-if="editable">
                                                    <a @click="showCompany(company)"
                                                        data-toggle="tooltip" title="Editar Empresa" class="text-secondary mr-1"
                                                    ><i class="fas fa-pen mx-1 icon-btn"></i></a>
                                                    <a @click="showModalDestroy(company)"
                                                        data-toggle="tooltip" title="Excluir Empresa" class="text-secondary"
                                                    ><i class="fas fa-times mx-1 icon-btn"></i></a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        
        <economic-group ref="modalCompany" @setEconomicGroup="storeEconomicGroupCompany" :economicGroup="dataFormEconomicGroup" />
        
        <div class="modal">
            <b-modal id="show-modal-del" ref="showModalDel" size="md" class="mt-4" hide-footer centered>
            <template #modal-title>Remover empresa</template>

            <div class="card card-termo-uso mb-3">
                <p class="mb-4">Deseja remover a empresa <strong>{{ formatCnpj(companySelected.cnpj) }} - {{ companySelected.company_name }}</strong> deste grupo econômico?</p>
            </div>
            <div class="row border-top py-4">
                <div class="col-12 col-lg-12 d-flex justify-content-between">
                    <button @click="$bvModal.hide('show-modal-del')"
                        class="btn btn-outline-secondary btn-lg text-uppercase px-4 mr-1">
                        <span class="d-none d-md-inline-block"> Cancelar</span>
                    </button>
                    
                    <button @click="deleteCompany(companySelected)" class="btn btn-primary btn-lg text-uppercase px-4"
                        data-toggle="modal">
                        Remover
                    </button>
                </div>
            </div>
            </b-modal>
        </div>

    </CollapseSection>
</template>

<script>
import { CollapseSection } from '@/components';
import { EconomicGroup } from "@/components/Client";
import commomsHelper from '@/mixins/commomsHelper';
import companyService from "@/services/company";
import economicGroupService from "@/services/economic-group";

export default {
    components: { 
        CollapseSection,
        EconomicGroup
    },
    props: {
        expanded: Boolean,
        disabled: Boolean,
        economicGroupID: String,
        editable: { type: Boolean, default: false }
    },
    mixins: [
        commomsHelper
    ],
    data: () => ({
        loading: false,
        selectedEconomicGroupTable: true,
        listEconomicGroupCompanies: [],
        dataFormEconomicGroup: {
            id: "",
            cnpj: "",
            company_name: "",
            type: 1,
            address: "",
            index: null,
        },
        companySelected: {}
    }),
    created() {
        if (this.economicGroupID && this.expanded) {
            this.getEconomicGroupCompanies();
        }
    },
    methods: {
        getEconomicGroupCompanies() {
            this.loading = true;
            economicGroupService
                .getEconomicGroupCompanies( this.economicGroupID )
                .then((response) => {
                    if (response.data.error) {
                        this.showError(response.data.message);
                        return;
                    }
                    this.listEconomicGroupCompanies = response.data;
                    this.selectedEconomicGroupTable = response.data.length > 0;
                })
                .catch((error) => {
                    this.showError(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        storeEconomicGroupCompany(data) {
            this.loading = true;
            companyService
                .registerTaker(this.economicGroupID, data)
                .then((response) => {
                    if (response.data.error) {
                        return;
                    }
                })
                .catch(() => {
                    this.showError("Não foi possível criar ou atualizar compania do grupo econômico.");
                })
                .finally(() => {
                    this.getEconomicGroupCompanies();
                    this.loading = false;
                    this.$nextTick(() => {
                        this.$refs.modalCompany?.closeModal();
                    });
                });
        },
        deleteCompany(data) {
            this.loading = true;
            companyService
                .deleteCompany(data.id)
                .then((response) => {
                    if (response.data.error) {
                        return;
                    }
                })
                .catch(() => {
                    this.showError("Não foi possível criar ou atualizar compania do grupo econômico.");
                })
                .finally(() => {
                    this.$bvModal.hide('show-modal-del');
                    this.companySelected = {};
                    this.getEconomicGroupCompanies();
                    this.loading = false;
                });
        },
        showCompany(data) {
            this.dataFormEconomicGroup.id = data.id;
            this.dataFormEconomicGroup.cnpj = data.cnpj;
            this.dataFormEconomicGroup.company_name = data.company_name;
            this.dataFormEconomicGroup.address = data.address;
            this.dataFormEconomicGroup.type = data.type;
            this.dataFormEconomicGroup.index = data.index;
            this.dataFormEconomicGroup.old_cnpj = this.dataFormEconomicGroup.cnpj;
            this.$bvModal.show("show-modal-company");
        },
        showModalDestroy(companySelected) {
            this.$refs.showModalDel.show();
            this.companySelected = companySelected;
        },
    },  
    watch: {
        expanded: function (value) {
            if (value) {
                this.resetAlert();
                this.getEconomicGroupCompanies();
            }
        },
    }
}
</script>
<style>
</style>
